import { useEffect } from 'react'
import { useLocation, useNavigationType } from 'react-router-dom'

/**
 * Scroll to top on route change.
 * - Keeps scroll when user uses Back/Forward (POP), like browser native behavior.
 * - Scrolls to top for normal navigation (PUSH/REPLACE).
 */
export function ScrollToTopNextRoute() {
  const { pathname, search, hash } = useLocation()
  const navType = useNavigationType() // PUSH | POP | REPLACE

  useEffect(() => {
    // Keep native behavior for back/forward navigation
    if (navType === 'POP') return

    // If route has hash (#section), let the browser handle it
    if (hash) return

    // Scroll the window to top
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [pathname, search, hash, navType])

  return null
}
